define([
	"dojo/_base/declare",
	"csi/html",
	"dijit/form/CheckBox"
], function(declare, html, CheckBox) {

	return declare(CheckBox, {
		// allow use of "value" attribute rather than "checked" to be consistent with other widgets

		postCreate: function() {
			// Here was code which was added to address C8-47202
			// Now I (Egor) have deleted that code to address C8-57349
			// Removed code used to create div clicking area to cover checkbox input and process events and add some styling
			// For more info and details please see comments in C8-57349

			if (this.params.checkboxLabel) {
				html.create("div", {
					"class": "csi-checkbox-label",
					innerText : this.params.checkboxLabel,
				}, this.domNode.firstChild, "before");
			}
		},

		_getValueAttr: function() {
			// summary: return boolean value based on checked state rather than value when checked
			return this.checked;
		},

		_setValueAttr: function(/*String|Boolean*/ newValue, /*Boolean*/ priorityChange) {
			// summary: ensure that we are setting boolean value
			var checked = !!newValue;
			this.set("checked", checked);
			this.inherited(arguments, [checked ? "on" : false, priorityChange]);
		}
	});
});